// eslint-disable-next-line
import * as actions from "constants/notificationConstants";

interface IActions {
  type: string;
  payload?: string;
}

export const notificationReducer = (
  state = { notifications: [] },
  action: IActions
) => {
  switch (action.type) {
    default:
      return state;
  }
};
